import { cEl } from '../../../util';
import ImageMask from './ImageMask';

function HomeSlide({ src, name, imgStyle, title, description }) {
    const slideContainer = cEl('div');
    slideContainer.classList.add('carousel-slide');
    const img = ImageMask({ src, name });
    const contents = cEl('div');
    contents.classList.add('home-contents');

    for (const prop in imgStyle) {
        contents.style[prop] = imgStyle[prop];
    }

    contents.innerHTML = `
    <h2>${title}</h2>
    <span>${description}</span>
    `;

    slideContainer.append(img, contents);
    return slideContainer;
}

export default HomeSlide;
